import { render, staticRenderFns } from "./ClientiPotenziali.vue?vue&type=template&id=11506c36&"
import script from "./ClientiPotenziali.vue?vue&type=script&lang=js&"
export * from "./ClientiPotenziali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports